function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Content from '@nextcloud/vue/dist/Components/Content';
import AppContent from '@nextcloud/vue/dist/Components/AppContent';
import AppSidebar from '@nextcloud/vue/dist/Components/AppSidebar';
import AppSidebarTab from '@nextcloud/vue/dist/Components/AppSidebarTab';
import PersonsNavigation from './modules/persons/PersonsNavigation';
import PersonsSidebar from './modules/persons/PersonsSidebar';
import WeightSidebar from './modules/weight/WeightSidebar';
import FeelingSidebar from './modules/feeling/FeelingSidebar';
import ActionButton from '@nextcloud/vue/dist/Components/ActionButton';
import Actions from '@nextcloud/vue/dist/Components/Actions';
import WeightContent from './modules/weight/WeightContent';
import FeelingContent from './modules/feeling/FeelingContent';
import { mapState, mapGetters } from 'vuex';
import PersonsContent from './modules/persons/PersonsContent';
import SleepContent from './modules/sleep/SleepContent';
import MeasurementContent from './modules/measurement/MeasurementContent';
import MeasurementSidebar from './modules/measurement/MeasurementSidebar';
import SleepSidebar from './modules/sleep/SleepSidebar';
import moment from 'moment';
import SmokingSidebar from './modules/smoking/SmokingSidebar';
import SmokingContent from './modules/smoking/SmokingContent';
import ActivitiesContent from './modules/activities/ActivitiesContent';
import ActivitiesSidebar from './modules/activities/ActivitiesSidebar';
export default {
  name: 'App',
  components: {
    ActivitiesSidebar: ActivitiesSidebar,
    MeasurementContent: MeasurementContent,
    SleepContent: SleepContent,
    MeasurementSidebar: MeasurementSidebar,
    SleepSidebar: SleepSidebar,
    Content: Content,
    AppContent: AppContent,
    AppSidebar: AppSidebar,
    AppSidebarTab: AppSidebarTab,
    ActionButton: ActionButton,
    Actions: Actions,
    PersonsNavigation: PersonsNavigation,
    WeightSidebar: WeightSidebar,
    FeelingSidebar: FeelingSidebar,
    PersonsSidebar: PersonsSidebar,
    WeightContent: WeightContent,
    FeelingContent: FeelingContent,
    PersonsContent: PersonsContent,
    SmokingSidebar: SmokingSidebar,
    SmokingContent: SmokingContent,
    ActivitiesContent: ActivitiesContent
  },
  data: function data() {
    return {
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['activePersonId', 'activeModule', 'showSidebar', 'persons', 'initialLoading'])), mapGetters(['person'])),
  beforeMount: function beforeMount() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return _this.$store.dispatch('loadPersons');

            case 3:
              _this.loading = false;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    formatMyDate: function formatMyDate(v) {
      return moment(v).format('DD.MM.YYYY');
    }
  }
};